{
  "CONTACT_PANEL": {
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Cancel"
    },
    "NOT_AVAILABLE": "Not Available",
    "EMAIL_ADDRESS": "Email Address",
    "PHONE_NUMBER": "Phone number",
    "WHATSAPP_USERNAME": "WhatsApp username",
    "IDENTIFIER": "Identifier",
    "COPY_SUCCESSFUL": "Copied to clipboard successfully",
    "COPY_NAME": "Copy name",
    "COPY_REFERER": "Copy URL",
    "COMPANY": "Company",
    "LOCATION": "Location",
    "LTV": "LTV",
    "BROWSER_LANGUAGE": "Browser Language",
    "CONVERSATION_LANGUAGE": "Conversation Language",
    "CONVERSATION_TITLE": "Conversation Details",
    "VIEW_PROFILE": "View Profile",
    "BROWSER": "Browser",
    "OS": "Operating System",
    "INITIATED_FROM": "Initiated from",
    "INITIATED_AT": "Initiated at",
    "IP_ADDRESS": "IP Address",
    "CREATED_AT_LABEL": "Created",
    "NEW_MESSAGE": "New message",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "There are no previous conversations associated to this contact.",
      "TITLE": "Previous Conversations"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Contact Labels",
        "ERROR": "Couldn't update labels"
      },
      "CONVERSATION": {
        "TITLE": "Conversation Labels",
        "ADD_BUTTON": "Add Labels"
      },
      "LABEL_SELECT": {
        "TITLE": "Add Labels",
        "PLACEHOLDER": "Search labels",
        "NO_RESULT": "No labels found",
        "CREATE_LABEL": "Create new label"
      }
    },
    "MERGE_CONTACT": "Merge contact",
    "CONTACT_ACTIONS": "Contact actions",
    "MUTE_CONTACT": "Block Contact",
    "MUTE_CONTACT_DISABLED": "Cannot be used. The entire contact domain is blocked.",
    "UNMUTE_CONTACT": "Unblock Contact",
    "BLOCK_CONTACT_DOMAIN": "Block Contact Domain",
    "UNBLOCK_CONTACT_DOMAIN": "Unblock Contact Domain",
    "BLOCK_CONTACT_DOMAIN_DISABLED": "This contact domain cannot be blocked.",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blocking the domain will block all existing and future contacts for that domain.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Unblocking the domain will remove the block from all contacts for that domain (including those manually blocked).",
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Public email domain",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} is a public email domain used by many unrelated senders, so it cannot be blocked as a whole. Do you want to block only this address ({email})?",
    "BLOCK_ONLY_THIS_ADDRESS": "Block only this address",
    "MUTED_SUCCESS": "This contact is blocked successfully. Their conversations will be resolved in the background shortly.",
    "UNMUTED_SUCCESS": "This contact is unblocked successfully.",
    "OPEN_JARABOT": "Open AI Responses History",
    "TRANSLATE_CONVERSATION": "Translate Conversation",
    "TRANSLATE_INITIATED": "Translation started. This may take a moment for longer conversations.",
    "TRANSLATE_SUCCESS": "Conversation translation finished successfully.",
    "TRANSLATE_ERROR": "Failed to translate conversation. Please try again.",
    "MOVE_CONVERSATION": "Move Conversation",
    "MOVE_CONVERSATION_MISSING_EMAIL": "Contact email is required to move conversation to an email inbox",
    "MERGE_CONVERSATION": "Merge Conversation",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "This domain has been blocked successfully. You will not be notified of any future conversations.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "This domain has been unblocked successfully.",
    "SEND_TRANSCRIPT": "Send Transcript",
    "EDIT_LABEL": "Edit",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Custom Attributes",
      "CONTACT_LABELS": "Contact Labels",
      "PREVIOUS_CONVERSATIONS": "Previous Conversations",
      "NO_RECORDS_FOUND": "No attributes found"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Edit Contact",
    "TITLE": "Edit contact",
    "DESC": "Edit contact details"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Delete Contact",
    "TITLE": "Delete contact",
    "DESC": "Delete contact details",
    "CONFIRM": {
      "TITLE": "Confirm Deletion",
      "MESSAGE": "Are you sure to delete ",
      "YES": "Yes, Delete",
      "NO": "No, Keep"
    },
    "API": {
      "SUCCESS_MESSAGE": "Contact has been marked for deletion and will be automatically deleted shortly",
      "ERROR_MESSAGE": "Could not delete contact. Please try again later."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Save",
      "CANCEL": "Cancel",
      "UNSAVED_CHANGES": {
        "TITLE": "Unsaved changes",
        "DESCRIPTION": "You have unsaved changes. Do you want to save them before closing?",
        "CONFIRM": "Save",
        "CANCEL": "Discard"
      },
      "AVATAR": {
        "LABEL": "Contact Avatar"
      },
      "NAME": {
        "PLACEHOLDER": "Enter the full name of the contact",
        "LABEL": "Full Name"
      },
      "BIO": {
        "PLACEHOLDER": "Enter the bio of the contact",
        "LABEL": "Bio"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Enter the email address of the contact",
        "LABEL": "Email Address",
        "DUPLICATE": "This email address is in use for another contact.",
        "ERROR": "Please enter a valid email address."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Enter the phone number of the contact",
        "LABEL": "Phone Number",
        "HELP": "Phone number should be of E.164 format eg: +1415555555 [+][country code][area code][local phone number]. You can select the dial code from the dropdown.",
        "ERROR": "Phone number should be either empty or of E.164 format",
        "DIAL_CODE_ERROR": "Please select a dial code from the list",
        "DUPLICATE": "This phone number is in use for another contact."
      },
      "LOCATION": {
        "PLACEHOLDER": "Enter the location of the contact",
        "LABEL": "Location"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Enter the company name",
        "LABEL": "Company Name"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Enter the country name",
        "LABEL": "Country Name",
        "SELECT_PLACEHOLDER": "Select",
        "REMOVE": "Remove",
        "SELECT_COUNTRY": "Select Country"
      },
      "CITY": {
        "PLACEHOLDER": "Enter the city name",
        "LABEL": "City Name"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Enter the Facebook username",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Enter the Twitter username",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Enter the LinkedIn username",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Enter the Github username",
          "LABEL": "Github"
        }
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Contact avatar deleted successfully",
        "ERROR_MESSAGE": "Could not delete the contact avatar. Please try again later."
      }
    },
    "SUCCESS_MESSAGE": "Contact saved successfully",
    "ERROR_MESSAGE": "There was an error, please try again"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Start conversation",
    "TITLE": "New conversation",
    "DESC": "Start a new conversation by sending a new message.",
    "NO_INBOX": "Couldn't find an inbox to initiate a new conversation with this contact.",
    "FORM": {
      "TO": {
        "LABEL": "To"
      },
      "INBOX": {
        "LABEL": "Via Inbox",
        "PLACEHOLDER": "Choose source inbox",
        "ERROR": "Select an inbox"
      },
      "SUBJECT": {
        "LABEL": "Subject",
        "PLACEHOLDER": "Subject",
        "ERROR": "Subject can't be empty"
      },
      "MESSAGE": {
        "LABEL": "Message",
        "PLACEHOLDER": "Write your message here",
        "ERROR": "Message can't be empty"
      },
      "ATTACHMENTS": {
        "SELECT": "Choose files",
        "HELP_TEXT": "Drag and drop files here or choose files to attach"
      },
      "SUBMIT": "Send message",
      "CANCEL": "Cancel",
      "SUCCESS_MESSAGE": "Message sent!",
      "GO_TO_CONVERSATION": "View",
      "ERROR_MESSAGE": "Couldn't send! try again"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Social Profiles"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Add custom attribute",
    "COPY_SUCCESSFUL": "Copied to clipboard successfully",
    "SHOW_MORE": "Show all attributes",
    "SHOW_LESS": "Show less attributes",
    "ACTIONS": {
      "COPY": "Copy attribute",
      "DELETE": "Delete attribute",
      "EDIT": "Edit attribute"
    },
    "ADD": {
      "TITLE": "Create custom attribute",
      "DESC": "Add custom information to this contact."
    },
    "FORM": {
      "CREATE": "Add attribute",
      "CANCEL": "Cancel",
      "NAME": {
        "LABEL": "Custom attribute name",
        "PLACEHOLDER": "Eg: shopify id",
        "ERROR": "Invalid custom attribute name"
      },
      "VALUE": {
        "LABEL": "Attribute value",
        "PLACEHOLDER": "Eg: 11901 "
      },
      "ADD": {
        "TITLE": "Create new attribute ",
        "SUCCESS": "Attribute added successfully",
        "ERROR": "Unable to add attribute. Please try again later"
      },
      "UPDATE": {
        "SUCCESS": "Attribute updated successfully",
        "ERROR": "Unable to update attribute. Please try again later"
      },
      "DELETE": {
        "SUCCESS": "Attribute deleted successfully",
        "ERROR": "Unable to delete attribute. Please try again later"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Add attributes",
        "PLACEHOLDER": "Search attributes",
        "NO_RESULT": "No attributes found"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Select value",
          "SEARCH_INPUT_PLACEHOLDER": "Search value",
          "NO_RESULT": "No result found"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Valid value is required",
      "INVALID_URL": "Invalid URL",
      "INVALID_INPUT": "Invalid Input"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Merge contacts",
    "DESCRIPTION": "Merge contacts to combine two profiles into one, including all attributes and conversations. In case of conflict, the Primary contact’s attributes will take precedence.",
    "PRIMARY": {
      "TITLE": "Primary contact",
      "HELP_LABEL": "To be deleted"
    },
    "PARENT": {
      "TITLE": "Contact to merge",
      "PLACEHOLDER": "Search for a contact",
      "HELP_LABEL": "To be kept"
    },
    "SUMMARY": {
      "TITLE": "Summary",
      "DELETE_WARNING": "Contact of <strong>{primaryContactName}</strong> will be deleted.",
      "ATTRIBUTE_WARNING": "Contact details of <strong>{primaryContactName}</strong> will be copied to <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Something went wrong. Please try again later."
    },
    "FORM": {
      "SUBMIT": "Merge contacts",
      "CANCEL": "Cancel",
      "CHILD_CONTACT": {
        "ERROR": "Select a child contact to merge"
      },
      "SUCCESS_MESSAGE": "Contact merged successfully",
      "ERROR_MESSAGE": "Could not merge contacts, try again!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Contacts",
      "SEARCH_TITLE": "Search contacts",
      "SEARCH_PLACEHOLDER": "Search...",
      "MESSAGE_BUTTON": "Message",
      "SEND_MESSAGE": "Send message",
      "SHOW_DETAILS": "Contact details",
      "BLOCKING": "Blocking",
      "BLOCK_CONTACT": "Block contact",
      "UNBLOCK_CONTACT": "Unblock contact",
      "BLOCK_CONTACT_MESSAGE": "Blocking this contact will prevent them from creating new conversations and all their existing conversations will be resolved. Are you sure you want to block this contact?",
      "UNBLOCK_CONTACT_MESSAGE": "Unblocking this contact will allow them to create new conversations. Are you sure you want to unblock this contact?",
      "BLOCK_CONTACT_DISABLED": "Cannot be used. The entire contact domain is blocked.",
      "BLOCK_CONTACT_DOMAIN": "Block Contact Domain",
      "UNBLOCK_CONTACT_DOMAIN": "Unblock Contact Domain",
      "BLOCK_CONTACT_DOMAIN_DISABLED": "This contact domain cannot be blocked.",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blocking the domain will block all existing and future contacts for that domain.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Unblocking the domain will remove the block from all contacts for that domain (including those manually blocked).",
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Public email domain",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} is a public email domain used by many unrelated senders, so it cannot be blocked as a whole. Do you want to block only this contact ({email})?",
      "BLOCK_ONLY_THIS_CONTACT": "Block only this contact",
      "DIAL": "Dial",
      "BREADCRUMB": {
        "CONTACTS": "Contacts"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Add contact",
          "EXPORT_CONTACT": "Export contacts",
          "IMPORT_CONTACT": "Import contacts",
          "SAVE_CONTACT": "Save contact",
          "EMAIL_ADDRESS_DUPLICATE": "This email address is in use for another contact.",
          "PHONE_NUMBER_DUPLICATE": "This phone number is in use for another contact.",
          "SUCCESS_MESSAGE": "Contact saved successfully",
          "ERROR_MESSAGE": "Unable to save contact. Please try again later."
        },
        "BLOCK_SUCCESS_MESSAGE": "This contact is blocked successfully. Their conversations will be resolved in the background shortly.",
        "BLOCK_ERROR_MESSAGE": "Unable to block contact. Please try again later.",
        "UNBLOCK_SUCCESS_MESSAGE": "This contact is unblocked successfully",
        "UNBLOCK_ERROR_MESSAGE": "Unable to unblock contact. Please try again later.",
        "IMPORT_CONTACT": {
          "TITLE": "Import contacts",
          "DESCRIPTION": "Import contacts through a CSV file.",
          "DOWNLOAD_LABEL": "Download a sample csv.",
          "LABEL": "CSV File:",
          "CHOOSE_FILE": "Choose file",
          "CHANGE": "Change",
          "CANCEL": "Cancel",
          "IMPORT": "Import",
          "SUCCESS_MESSAGE": "You will be notified via email when the import is complete.",
          "ERROR_MESSAGE": "There was an error, please try again"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Export contacts",
          "DESCRIPTION": "Quickly export a csv file with comprehensive details of your contacts",
          "CONFIRM": "Export",
          "SUCCESS_MESSAGE": "Export is in progress. You will be notified on email when the export file is ready to download.",
          "ERROR_MESSAGE": "There was an error, please try again"
        },
        "SORT_BY": {
          "LABEL": "Sort by",
          "OPTIONS": {
            "NAME": "Name",
            "EMAIL": "Email",
            "PHONE_NUMBER": "Phone number",
            "COMPANY": "Company",
            "COUNTRY": "Country",
            "CITY": "City",
            "LAST_ACTIVITY": "Last activity",
            "CREATED_AT": "Created at"
          }
        },
        "ORDER": {
          "LABEL": "Ordering",
          "OPTIONS": {
            "ASCENDING": "Ascending",
            "DESCENDING": "Descending"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Do you want to save this filter?",
            "CONFIRM": "Save filter",
            "LABEL": "Name",
            "PLACEHOLDER": "Enter the name of the filter",
            "ERROR": "Enter a valid name",
            "SUCCESS_MESSAGE": "Filter saved successfully",
            "ERROR_MESSAGE": "Unable to save filter. Please try again later."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Confirm Deletion",
            "DESCRIPTION": "Are you sure you want to delete this filter?",
            "CONFIRM": "Yes, Delete",
            "CANCEL": "No, Cancel",
            "SUCCESS_MESSAGE": "Filter deleted successfully",
            "ERROR_MESSAGE": "Unable to delete filter. Please try again later."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "Name",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Phone number",
      "IDENTIFIER": "Identifier",
      "COUNTRY": "Country",
      "CITY": "City",
      "CREATED_AT": "Created at",
      "LAST_ACTIVITY": "Last activity",
      "REFERER_LINK": "Referer link",
      "BLOCKED": "Blocked",
      "BLOCKED_TRUE": "True",
      "BLOCKED_FALSE": "False",
      "BUTTONS": {
        "CLEAR_FILTERS": "Clear filters",
        "UPDATE_SEGMENT": "Update segment",
        "APPLY_FILTERS": "Apply filters",
        "ADD_FILTER": "Add filter"
      },
      "TITLE": "Filter contacts",
      "EDIT_SEGMENT": "Edit segment",
      "SEGMENT": {
        "LABEL": "Segment name",
        "INPUT_PLACEHOLDER": "Enter the name of the segment"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} more filters",
        "CLEAR_FILTERS": "Clear filters"
      }
    },
    "CARD": {
      "OF": "of",
      "VIEW_DETAILS": "View details",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Edit contact details",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Enter the first name",
            "ERROR": "First name is required."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Enter the last name"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Enter the email address",
            "DUPLICATE": "This email address is in use for another contact.",
            "ERROR": "Please enter a valid email address."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Enter the phone number",
            "DUPLICATE": "This phone number is in use for another contact."
          },
          "CITY": {
            "PLACEHOLDER": "Enter the city name"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Select country"
          },
          "BIO": {
            "PLACEHOLDER": "Enter the bio"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Enter the company name"
          }
        },
        "UPDATE_BUTTON": "Update contact",
        "SUCCESS_MESSAGE": "Contact updated successfully",
        "ERROR_MESSAGE": "Unable to update contact. Please try again later."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Edit social links",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Add Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Add Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Add Instagram"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "Add WhatsApp"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Add LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Add Twitter"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Created {date}",
      "LAST_ACTIVITY": "Last active {date}",
      "DELETE_CONTACT_DESCRIPTION": "Permanently delete this contact. This action is irreversible",
      "DELETE_CONTACT": "Delete contact",
      "DELETE_DIALOG": {
        "TITLE": "Confirm Deletion",
        "DESCRIPTION": "Are you sure you want to delete this {contactName} contact?",
        "CONFIRM": "Yes, Delete",
        "API": {
          "SUCCESS_MESSAGE": "Contact has been marked for deletion and will be automatically deleted shortly",
          "ERROR_MESSAGE": "Could not delete contact. Please try again later."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Could not upload avatar. Please try again later.",
          "SUCCESS_MESSAGE": "Avatar uploaded successfully"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar deleted successfully",
          "ERROR_MESSAGE": "Could not delete avatar. Please try again later."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Attributes",
        "HISTORY": "Conversation history",
        "NOTES": "Notes",
        "MERGE": "Merge",
        "ORDER_HISTORY": "Recent Orders",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "There are no previous conversations associated to this contact"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Search for attributes",
        "UNUSED_ATTRIBUTES": "{count} Used attribute | {count} Unused attributes",
        "EMPTY_STATE": "There are no contact custom attributes available in this account. You can create a custom attribute in settings.",
        "YES": "Yes",
        "NO": "No",
        "TRIGGER": {
          "SELECT": "Select value",
          "INPUT": "Enter value"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Invalid number",
          "REQUIRED": "Valid value is required",
          "INVALID_INPUT": "Invalid input",
          "INVALID_URL": "Invalid URL",
          "INVALID_DATE": "Invalid date"
        },
        "NO_ATTRIBUTES": "No attributes found",
        "API": {
          "SUCCESS_MESSAGE": "Attribute updated successfully",
          "DELETE_SUCCESS_MESSAGE": "Attribute deleted successfully",
          "UPDATE_ERROR": "Unable to update attribute. Please try again later",
          "DELETE_ERROR": "Unable to delete attribute. Please try again later"
        }
      },
      "MERGE": {
        "TITLE": "Merge contact",
        "DESCRIPTION": "Combine two profiles into one, including all attributes and conversations. In case of conflict, the primary contact’s attributes will take precedence.",
        "PRIMARY": "Primary contact",
        "PRIMARY_HELP_LABEL": "To be saved",
        "PRIMARY_REQUIRED_ERROR": "Please select a contact to merge with before proceeding",
        "PARENT": "To be merged",
        "PARENT_HELP_LABEL": "To be deleted",
        "EMPTY_STATE": "No contacts found",
        "PLACEHOLDER": "Search for primary contact",
        "SEARCH_PLACEHOLDER": "Search for a contact",
        "SEARCH_ERROR_MESSAGE": "Could not search for contacts. Please try again later.",
        "SUCCESS_MESSAGE": "Contact merged successfully",
        "ERROR_MESSAGE": "Could not merge contacts, try again!",
        "IS_SEARCHING": "Searching...",
        "BUTTONS": {
          "CANCEL": "Cancel",
          "CONFIRM": "Merge contact"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Add a note",
        "WROTE": "wrote",
        "YOU": "You",
        "SAVE": "Save note",
        "EMPTY_STATE": "There are no notes associated to this contact. You can add a note by typing in the box above."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "No contacts found in this account",
      "SUBTITLE": "Start adding new contacts by clicking on the button below",
      "BUTTON_LABEL": "Add contact",
      "SEARCH_EMPTY_STATE_TITLE": "No contacts matches your search 🔍",
      "LIST_EMPTY_STATE_TITLE": "No contacts available in this view 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "New Conversation",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn't complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "View",
      "SUCCESS_MESSAGE": "The message was sent successfully!",
      "ERROR_MESSAGE": "An error occurred while creating the conversation. Please try again later.",
      "NO_INBOX_ALERT": "There are no available inboxes to start a conversation with this contact.",
      "CONTACT_SELECTOR": {
        "LABEL": "To:",
        "TAG_INPUT_PLACEHOLDER": "Search for a contact with name, email or phone number",
        "CONTACT_CREATING": "Creating contact..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Via:",
        "BUTTON": "Show inboxes"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Subject :",
        "SUBJECT_PLACEHOLDER": "Enter your email subject here",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_LABEL": "Bcc:",
        "BCC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_BUTTON": "Bcc"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Write your message here..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp template: {templateName}",
          "VARIABLES": "Variables",
          "BACK": "Go back",
          "SEND_MESSAGE": "Send message"
        }
      },
      "ACTION_BUTTONS": {
        "SEND": "Send ({keyCode})",
        "MARK_RESOLVED": "Mark new conversation as resolved after sending",
        "SAVE_DRAFT": "Save Draft",
        "CREATE_AS_INTERNAL": "Create as conversation with note",
        "SEND_AND_RESOLVE_ORIGINAL": "Send and resolve original conversation ({keyCode})"
      },
      "DISCARD": "Discard draft",
      "DISCARD_MODAL": {
        "TITLE": "Discard Draft",
        "DESCRIPTION": "Are you sure you want to discard this draft?",
        "CONFIRM": "Yes, discard",
        "CANCEL": "No, keep"
      }
    }
  }
}
